import { Input, InfoBox } from '@ics-portal/guardian';
import { type ReactNode, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LatLng } from 'leaflet';
import { ModalDivided } from '@components/_atoms/ModalDivided/ModalDivided';
import { Section } from '@components/shared/Section';
import { type ProjectFormAttributes } from '../../ProjectForm';
import { ProjectLocationEditor } from '../../../ProjectLocationEditor/ProjectLocationEditor';

export function ProjectFormCustomer(): ReactNode {
    const { watch, control, setValue } =
        useFormContext<ProjectFormAttributes>();
    const longitude = watch('longitude');
    const latitude = watch('latitude');

    useEffect(() => {
        if (latitude === undefined || longitude === undefined) {
            setValue('pointInput', undefined);
            return;
        }
        setValue('pointInput', {
            latitude: Number(latitude),
            longitude: Number(longitude),
        });
    }, [latitude, longitude, setValue]);

    const latLng =
        latitude !== undefined && longitude !== undefined
            ? new LatLng(latitude, longitude)
            : undefined;

    return (
        <div className="flex flex-column gap-3">
            <InfoBox>
                Please add customer information and project location if
                necessary.
            </InfoBox>
            <ModalDivided>
                <Section title="Customer" className="gap-0">
                    <Input
                        id="customerName"
                        name="customerName"
                        label="Name"
                        required
                    />
                    <Input
                        id="customerEmail"
                        name="customerEmail"
                        label="Email"
                    />
                    <Input
                        id="customerPhone"
                        name="customerPhone"
                        label="Phone"
                    />
                    <Input
                        id="customerAddress"
                        name="customerAddress"
                        label="Address"
                    />
                    <Input id="plantName" name="plantName" label="Plant Name" />
                    <Input
                        id="plantExternalID"
                        name="plantExternalID"
                        label="Plant External ID"
                    />
                </Section>
                <Section title="Project Location" className="gap-0">
                    <Input
                        id="locationStreet"
                        name="locationStreet"
                        label="Street"
                    />
                    <Input
                        id="locationPostalCode"
                        name="locationPostalCode"
                        label="Postal Code"
                    />
                    <Input id="locationCity" name="locationCity" label="City" />
                    <Input
                        id="locationCountry"
                        name="locationCountry"
                        label="Country"
                    />
                    <Input
                        id="longitude"
                        name="longitude"
                        label="Longitude"
                        type="number"
                    />
                    <Input
                        id="latitude"
                        name="latitude"
                        label="Latitude"
                        type="number"
                    />
                    <div className="flex justify-content-end">
                        <Controller
                            name="pointInput"
                            control={control}
                            render={({ field }) => (
                                <ProjectLocationEditor
                                    latLng={latLng}
                                    buttonProps={{
                                        label: 'Select location on map',
                                    }}
                                    onChange={(e) => {
                                        field.onChange({
                                            latitude: e.lat,
                                            longitude: e.lng,
                                        });

                                        setValue('latitude', e.lat, {
                                            shouldDirty: true,
                                        });
                                        setValue('longitude', e.lng, {
                                            shouldDirty: true,
                                        });
                                    }}
                                />
                            )}
                        />
                    </div>
                </Section>
            </ModalDivided>
        </div>
    );
}
